// src/components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Layout.scss";

export default function Layout() {
  return (
    <div className="main font-normal leading-7">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}